import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import styles from "./basket-navigation.module.css";
export var CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(CheckoutStage || (CheckoutStage = {}));
var getLastCheckoutStage = function(activeOrder) {
    var ref;
    var storageLastCheckoutStage = "object" !== "undefined" ? JSON.parse((ref = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("checkout-last-visited-stage")) !== null && ref !== void 0 ? ref : "{}") : null;
    if (!activeOrder) {
        return;
    }
    var ref1 = storageLastCheckoutStage !== null && storageLastCheckoutStage !== void 0 ? storageLastCheckoutStage : {}, orderId = ref1.orderId, stage = ref1.stage;
    if (orderId === activeOrder.id && stage) {
        return storageLastCheckoutStage;
    }
    return {
        orderId: activeOrder.id,
        stage: CheckoutStage.PersonalDetails
    };
};
export var personalDetailsPagePath = "/checkout/personal-details/";
export var findVehiclePath = "/find-vehicle/";
var formatPath = function(checkoutStage) {
    // Split camel case string before each uppercase letter
    var formattedPath = checkoutStage.split(/(?=[A-Z])/).join("-").toLowerCase();
    return "/checkout/".concat(formattedPath, "/");
};
export var returnToCheckoutStage = function(checkoutStep, activeOrder) {
    var vehicle = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle;
    var orderId = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id;
    var path = formatPath(checkoutStep);
    switch(checkoutStep){
        case CheckoutStage.PersonalDetails:
            return vehicle ? "".concat(personalDetailsPagePath).concat(vehicle.id) : findVehiclePath;
        case CheckoutStage.PartExchange:
        case CheckoutStage.Finance:
        case CheckoutStage.DeliverySlots:
        case CheckoutStage.Extras:
        case CheckoutStage.CinchCare:
        case CheckoutStage.Payment:
            return orderId ? "".concat(path).concat(orderId) : null;
        default:
            return null;
    }
};
export var BasketComponent = function(param) {
    var children = param.children, setShouldShowCheckoutModal = param.setShouldShowCheckoutModal, _tag = param.tag, tag = _tag === void 0 ? "button" : _tag;
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var handleTrackEvent = logicStore.handleTrackEvent;
    var userStore = useContext(SharedUiHeaderV2Context).userStore;
    var activeOrder = userStore.activeOrder;
    var checkoutLink;
    var orderInformation = getLastCheckoutStage(activeOrder);
    if (orderInformation && orderInformation.stage) {
        var stage = CheckoutStage[orderInformation.stage];
        checkoutLink = returnToCheckoutStage(stage, activeOrder);
    }
    var handleClick = function() {
        setShouldShowCheckoutModal();
        handleTrackEvent({
            name: "click",
            category: "mega menu",
            label: "basket",
            action: "button"
        });
    };
    var Tag = tag === "a" ? "a" : "button";
    return /*#__PURE__*/ _jsx(Tag, {
        "data-testid": "checkout-basket",
        "aria-label": "Your basket order",
        className: styles.basketContainer,
        onClick: handleClick,
        href: tag === "a" ? checkoutLink !== null && checkoutLink !== void 0 ? checkoutLink : undefined : undefined,
        children: children
    });
};
